import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FieldConfigName} from '../../../models';
import {AvisInputDialogComponent} from './avis-input-dialog.component';
import {FieldControlMaster} from '../control-master-label-required';

@Component({
  selector: 'app-avis-input',
  templateUrl: './avis-input.component.html',
  styleUrls: ['./avis-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AvisInputComponent extends FieldControlMaster implements OnInit {
  @Output() avisInputUpdateControl = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() avisInputDelete = new EventEmitter<number>();
  dialogComponent = AvisInputDialogComponent;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }
  onUpdatedControl(object) {
    this.avisInputUpdateControl.emit(object);
  }
  onDeletedControl(index: number) {
    this.avisInputDelete.emit(index);
  }
}
